// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ValidatedForm_disabled___M7Px"};